module.exports = __webpack_public_path__ + "img/ico-search.35046d09.svg";